/// <amd-module name="Dashboards/DashboardView/src/components/DashboardView" />
import * as React from "react";

import { DashboardViewRootProviderProps } from "../redux/RootProviderProps";
import { DashboardViewSagaContext } from "../redux/sagas/SagaContext";
import { ConnectedDashboardContentGuard } from "./DashboardContentGuard";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IRootProviderProps, RootProvider } from "VSS/Redux/Deprecated/RootProvider";

/**
 * View of an individual dashboard.
 * The entry point for rendering a dashboard.
 * Sets up the root provider for redux.
 */
class DashboardView extends VssComponent {
    private rootProviderProps: IRootProviderProps<DashboardViewSagaContext, any>;

    constructor(props: never, context: IVssComponentContext) {
        super(props, context);

        this.rootProviderProps = DashboardViewRootProviderProps.get(context.pageContext);
    }

    public render(): JSX.Element | undefined {
        return (
            <RootProvider {...this.rootProviderProps}>
                <div className="dashboard-view">
                    <ConnectedDashboardContentGuard />
                </div>
            </RootProvider>
        );
    }
}

VssComponent.register("dashboard-view", DashboardView);
